// extracted by mini-css-extract-plugin
module.exports = {"marqueeContent":"Marquee_marqueeContent__sjX33","scroll":"Marquee_scroll__u5RYT","marquee":"Marquee_marquee__w9oSp","reverse":"Marquee_reverse__LOZMt"};